import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  /**
   * Constructor to inject services
   * @param authService Service to handle authentication
   */
  constructor(private readonly authService: AuthService) {}

  /**
   * Determines if a route can be activated
   * @returns boolean indicating if the route can be activated
   */
  canActivate(): boolean {
    const currentUser = this.authService.currentUserValue;
    
    if (currentUser) {
      return true;
    }
    this.authService.logout();
    return false;
  }
}
